export default "__VITE_ASSET__CkBP7Xv___"